import { Snackbar, Alert, Fade } from '@mui/material';
import { useNotification } from '../../context/NotificationContext';

const Notification: React.FC = () => {
  const { notification, hideNotification } = useNotification();

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') return; // Nicht automatisch beim Klick außerhalb schließen
    hideNotification();
  };

  return (
    <Snackbar
      key={notification.key}
      open={notification.open}
      autoHideDuration={15000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={(props) => <Fade {...props} />}
      sx={{
        mt: '50px',
      }}
    >
      <Alert 
        onClose={hideNotification} 
        severity={notification.type} 
        sx={{ 
          width: '100%',
          '& .MuiAlert-message': {
            fontSize: '0.875rem',
            fontWeight: 500
          }
        }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;